import { List } from 'immutable';

/**
 * Clear every slot of an Immutable.js List to `undefined`, preserving the
 * list's size.
 *
 * Immutable `List.set(index, value)` is persistent: it returns a NEW list and
 * never mutates in place. Code that calls `.set(...)` in a loop and discards
 * the return clears nothing (the bug this fixes: MUS-506). This helper
 * reassigns the returned list on each step and returns the fully-cleared list,
 * so callers do `ref.current = clearPhraseSlots(ref.current)`.
 *
 * The input list is not modified (Immutable guarantees this).
 */
export function clearPhraseSlots<T>(list: List<T | undefined>): List<T | undefined> {
  let cleared = list;
  for (let i = 0; i < cleared.size; i++) {
    cleared = cleared.set(i, undefined);
  }
  return cleared;
}
